/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-script-url */
import "../../../../../assets/styles/chat.css";

const DiscussionsTab = ({ sinistre }) => {
    return (
        <div className="card-body">
            <div className="container" justify="center">
                <div className="col-12">
                    <div className="nav-align-top nav-tabs-shadow">
                        <ul className="nav nav-tabs nav-fill" role="tablist">
                            <li className="nav-item">
                                <button
                                    type="button"
                                    className="nav-link active"
                                    role="tab"
                                    data-bs-toggle="tab"
                                    data-bs-target="#navs-justified-home"
                                    aria-controls="navs-justified-home"
                                    aria-selected="true"
                                >
                                    <span className="d-none d-sm-inline-flex align-items-center">
                                        <i className="icon-base bx bxs-file-find icon-sm me-1_5" />
                                        Discussions
                                        <span className="badge rounded-pill badge-center h-px-20 w-px-20 bg-label-danger ms-1_5">
                                            0
                                        </span>
                                    </span>
                                    <i className="icon-base bx bx-home icon-sm d-sm-none" />
                                </button>
                            </li>
                        </ul>
                        <div className="tab-content">
                            <div className="tab-pane fade show active" id="navs-justified-home" role="tabpanel">
                                <div className="app-chat chat-history-wrapper">
                                    <div className="col app-chat-history" id="app-chat-history">
                                        <div className="chat-history-wrapper">
                                            <div className="chat-history-header border-bottom">
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <div className="d-flex overflow-hidden align-items-center">
                                                        <div className="chat-contact-info flex-grow-1 ms-4">
                                                            <h6 className="m-0 fw-normal">Discussions</h6>
                                                            <small className="user-status text-body">
                                                                Sinistre N° {sinistre?.numSinistre}
                                                            </small>
                                                        </div>
                                                    </div>
                                                    <div className="d-flex align-items-center">
                                                        <span className="btn btn-text-secondary text-secondary cursor-pointer d-sm-inline-flex d-none me-1 btn-icon rounded-pill">
                                                            <i className="icon-base bx bx-search icon-md" />
                                                        </span>
                                                        <div className="dropdown">
                                                            <button
                                                                className="btn btn-icon btn-text-secondary text-secondary rounded-pill dropdown-toggle hide-arrow"
                                                                data-bs-toggle="dropdown"
                                                                aria-expanded="true"
                                                                id="chat-header-actions"
                                                            >
                                                                <i className="icon-base bx bx-dots-vertical-rounded icon-md" />
                                                            </button>
                                                            <div
                                                                className="dropdown-menu dropdown-menu-end"
                                                                aria-labelledby="chat-header-actions"
                                                            >
                                                                <a className="dropdown-item" href="javascript:void(0);">
                                                                    View Contact
                                                                </a>
                                                                <a className="dropdown-item" href="javascript:void(0);">
                                                                    Mute Notifications
                                                                </a>
                                                                <a className="dropdown-item" href="javascript:void(0);">
                                                                    Block Contact
                                                                </a>
                                                                <a className="dropdown-item" href="javascript:void(0);">
                                                                    Clear Chat
                                                                </a>
                                                                <a className="dropdown-item" href="javascript:void(0);">
                                                                    Report
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="chat-history-body" />
                                            <div className="chat-history-footer shadow-xs">
                                                <form className="form-send-message d-flex justify-content-between align-items-center">
                                                    <input
                                                        className="form-control message-input border-0 me-4 shadow-none"
                                                        placeholder="Entrez votre message..."
                                                    />
                                                    <div className="message-actions d-flex align-items-center">
                                                        <label htmlFor="attach-doc" className="form-label mb-0">
                                                            <span className="btn btn-text-secondary btn-icon rounded-pill cursor-pointer mx-1">
                                                                <i className="icon-base bx bx-paperclip icon-md text-heading" />
                                                            </span>
                                                            <input type="file" id="attach-doc" hidden />
                                                        </label>
                                                        <button className="btn btn-primary d-flex send-msg-btn" type="button">
                                                            <span className="align-middle d-md-inline-block d-none">Envoyer</span>
                                                            <i className="icon-base bx bx-paper-plane icon-sm ms-md-2 ms-0" />
                                                        </button>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DiscussionsTab;
